<template>
  <div>
    <media
      :entity-id="locationId"
      entity-key="location_id"
      :api-config="apiConfig"
      :can-edit-media="canEditLocations()"
      :is-disabled="isDisabled"
    />
  </div>
</template>

<script>
import locations from "../../network/locations";
  import permissions, {PERM} from "../../utilites/permissions";
    import Media from "../../utilites/commonUi/Media.vue";

export default {
  name: 'LocationMedia',
  components: { Media },
  mixins: [
    locations,
    permissions
  ],
  props: {
    isDisabled: Boolean,
    locationId: { type: Number, default: null }
  },
  computed: {
    apiConfig() {
      return {
        getMedia: this.getLocationMedia,
        postMedia: this.postLocationMedia,
        putMedia: this.putLocationMedia,
        deleteMedia: this.deleteLocationMedia,
        getFiles: this.getLocationMediaFiles,
        getFileDownload: this.getLocationMediaFileDownload,
        postFile: this.postLocationMediaFiles,
        deleteFile: this.deleteLocationMediaFiles
      };
    }
  },
  methods: {
    canEditLocations() {
      return this.hasPermission([PERM.LOCATION_EDIT]);
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationMedia.vue